"use client";

import { CustomSelect } from "@/components/shared/formElements/CustomSelect";
import {
  PublicListingFilterField,
  PublicListingFiltersModal,
} from "@/views/shared/public-listing";

export interface LocationsPublicFiltersDraft {
  city: string | null;
}

export const EMPTY_LOCATIONS_PUBLIC_FILTERS_DRAFT: LocationsPublicFiltersDraft = {
  city: null,
};

export function countLocationsPublicFilters(
  filters: LocationsPublicFiltersDraft,
): number {
  return filters.city ? 1 : 0;
}

export function LocationsPublicFiltersModal({
  isOpen,
  onClose,
  draft,
  onDraftChange,
  onApply,
  onClearDraft,
  cityOptions,
}: {
  isOpen: boolean;
  onClose: () => void;
  draft: LocationsPublicFiltersDraft;
  onDraftChange: (next: LocationsPublicFiltersDraft) => void;
  onApply: () => void;
  onClearDraft: () => void;
  cityOptions: string[];
}) {
  return (
    <PublicListingFiltersModal
      isOpen={isOpen}
      onClose={onClose}
      title="Filter locations"
      onApply={onApply}
      onClearDraft={onClearDraft}
      hasDraftCriteria={countLocationsPublicFilters(draft) > 0}
      testId="locations-public-filters-modal"
      applyTestId="locations-public-filters-apply"
    >
      {cityOptions.length > 1 ? (
        <PublicListingFilterField label="City">
          <CustomSelect
            placeholder="All cities"
            value={draft.city ?? ""}
            onChange={(val) =>
              onDraftChange({ city: val === "" ? null : val })
            }
            options={[
              { label: "All cities", value: "" },
              ...cityOptions.map((city) => ({
                label: city,
                value: city,
              })),
            ]}
          />
        </PublicListingFilterField>
      ) : null}
    </PublicListingFiltersModal>
  );
}
